// src/api/negociosApi.js
//
// Endpoints para el directorio de negocios y su detalle:
// - GET /api/holaveci/negocios              lista con filtros
// - GET /api/holaveci/negocios/{id}         detalle
// - GET /api/holaveci/negocios/{id}/productos
// - GET /api/holaveci/productos/{id}        producto individual
// - GET /api/holaveci/buscar                búsqueda global (tiendas + productos)

import { api } from './apiClient';

export const negocios = {
  /**
   * Lista negocios activos con filtros. Si se pasa lat/lng, ordena por
   * distancia y devuelve DistanciaKm. Si además se pasa radioKm, filtra
   * solo los que están dentro.
   */
  listar: (params = {}) =>
    api.get('/api/holaveci/negocios', { query: params }),

  detalle: (id) =>
    api.get(`/api/holaveci/negocios/${id}`),

  productos: (id, params = {}) =>
    api.get(`/api/holaveci/negocios/${id}/productos`, { query: params }),
};

export const productos = {
  detalle: (id) => api.get(`/api/holaveci/productos/${id}`),
};

/** Búsqueda global: devuelve tiendas y productos que matchean q. */
export const buscarGlobal = (q, lat, lng, radioKm) =>
  api.get('/api/holaveci/buscar', { query: { q, lat, lng, radioKm } });
